var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "header w-100",
      style: { top: -this.top + "px" },
      attrs: { id: "ep__header" }
    },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c(
            "div",
            { staticClass: "header__left" },
            [
              _c(
                "router-link",
                {
                  attrs: { to: "/" + _vm.currentFlag.countryCode.toLowerCase() }
                },
                [
                  _c("img", {
                    attrs: { src: require("@static/img/logo.svg"), alt: "" }
                  })
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "header__right d-flex align-items-center" },
            [
              _c(
                "router-link",
                {
                  staticClass: "header__button text-decoration-none",
                  attrs: {
                    to:
                      "/" +
                      _vm.currentFlag.countryCode.toLowerCase() +
                      "/contact-us"
                  }
                },
                [
                  _c("img", {
                    attrs: { src: require("@static/img/phone.svg"), alt: "" }
                  }),
                  _vm._v("Contact us")
                ]
              ),
              _c(
                "div",
                { staticClass: "header__form d-flex align-items-center" },
                [
                  _c("div", [_vm._v("Country")]),
                  _c("EpDropdown", {
                    attrs: {
                      items: _vm.supportedCountries,
                      itemKey: "countryCode",
                      selectedItem: _vm.currentFlag,
                      dropdownClass: "flag-dropdown"
                    },
                    on: { "update:selectedItem": _vm.handleFlagChange },
                    scopedSlots: _vm._u([
                      {
                        key: "selectedItem",
                        fn: function(ref) {
                          var selectedItem = ref.selectedItem
                          return [
                            _c(
                              "div",
                              { staticClass: "country-dropdown-trigger" },
                              [
                                _c("img", {
                                  staticClass: "area-code",
                                  attrs: {
                                    src: _vm.getFlagUrl(
                                      selectedItem.countryCode
                                    ),
                                    alt: selectedItem.countryValue,
                                    width: "32"
                                  }
                                }),
                                _c("img", {
                                  staticClass: "img-24 ml-8",
                                  attrs: {
                                    src: require("@static/img/dropdown.svg"),
                                    alt: ""
                                  }
                                })
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "item",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("img", {
                              staticClass: "mr-16 area-code",
                              attrs: {
                                src: _vm.getFlagUrl(item.countryCode),
                                alt: item.countryValue,
                                width: "32"
                              }
                            }),
                            _vm._v(" " + _vm._s(item.countryValue) + " ")
                          ]
                        }
                      }
                    ])
                  }),
                  _c("div", { staticClass: "header__label" }, [
                    _vm._v("Language")
                  ]),
                  _c("span", { staticClass: "header__lang" }, [
                    _vm._v(_vm._s(_vm.displayLanguage.toUpperCase()))
                  ]),
                  _vm._t("header-right")
                ],
                2
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }